<template>
  <el-select
    v-on="$listeners"
    class="currency-select"
    placeholder="Select currency"
    size="small"
    :value="value">
    <el-option
      v-for="item in currencyList"
      :key="item.id"
      :label="item.name"
      :value="item.id" />
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "CurrencySelect",
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      currencyList: 'currencyList',
    }),
  },
  methods: {
    ...mapActions({
      fetchCurrencyList: 'fetchCurrencyList',
    }),
  },
  created() {
    if (!this.currencyList.length) {
      this.fetchCurrencyList();
    }
  }
}
</script>

<style scoped lang="scss">
.currency-select {
  max-width: 234px;
  margin-right: auto;
}
</style>
